// extracted by mini-css-extract-plugin
export default {"pageWrapper":"TokenLoansPage-module__pageWrapper--rNJw9"};